/* NC · Cart Trust */
(function () {
  var cfg = (window.NC || {}).cartTrust;
  if (!cfg || !Array.isArray(cfg.hypotheses) || !cfg.hypotheses.length) return;

  var ICONS = {
    secure:   '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 4 5v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V5l-8-3Z"/><path d="M9 12l2 2 4-4"/></svg>',
    returns:  '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/></svg>',
    delivery: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 5h13v11H1z"/><path d="M14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>',
    lock:     '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>'
  };
  var s = cfg.strings || {}, pay = cfg.paymentsHtml || '';

  function qp(n){ try { return new URLSearchParams(location.search).get(n); } catch(e){ return null; } }
  var preview = qp('nc_preview');

  function item(i, t){ return '<div class="nc-cart-trust__item">' + i + '<span>' + t + '</span></div>'; }
  function badges(){ return '<div class="nc-cart-trust__grid">' + item(ICONS.secure, s.secure) + item(ICONS.returns, s.returns) + item(ICONS.delivery, s.delivery) + '</div>'; }
  function line(){
    return '<p class="nc-cart-trust__line">' + ICONS.lock +
      '<span>' + s.secure + '</span><span class="nc-cart-trust__sep">|</span>' +
      '<span>' + s.returns + '</span><span class="nc-cart-trust__sep">|</span>' +
      '<span>' + s.delivery + '</span></p>';
  }
  function html(v){
    var payRow = pay ? '<div class="nc-cart-trust__payments">' + pay + '</div>' : '';
    return '<div class="nc-cart-trust nc-cart-trust--' + v + '" data-nc-cart-trust>' + payRow + (v === 'a' ? line() : badges()) + '</div>';
  }

  function btnNow(){
    var b = document.querySelector('.candyrack-slider-cart-footer-checkout-button')
         || document.querySelector('.candyrack-slider-cart-footer-wrapper button[name="checkout"]');
    return (b && (b.offsetWidth || b.offsetHeight || b.getClientRects().length)) ? b : null;
  }
  function place(btn, v){
    var footer = btn.closest('.candyrack-slider-cart-footer-wrapper') || btn.parentNode;
    if (footer.querySelector('[data-nc-cart-trust]')) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html(v);
    var bw = btn.closest('.candyrack-slider-cart-footer-buttons-wrapper') || btn.parentNode;
    bw.parentNode.insertBefore(tmp.firstElementChild, bw.nextSibling);
  }

  var decided = false, active = null, deciding = null;
  function decide(){
    if (!deciding) deciding = (async function () {
      for (var i = 0; i < cfg.hypotheses.length; i++) {
        try { if (await window.shoplift.isHypothesisActive(cfg.hypotheses[i].id)) return cfg.hypotheses[i].variant; }
        catch (e) {}
      }
      return null;
    })();
    return deciding;
  }

  async function onChange(){
    var btn = btnNow();
    if (!btn) return;
    if (!decided) {
      if (preview === 'a' || preview === 'b') { decided = true; active = preview; }
      else { if (!window.shoplift) return; decided = true; active = await decide(); }
      if (active === 'a') document.documentElement.classList.add('nc-hide-subtotal');
    }
    if (active) place(btn, active);
  }

  new MutationObserver(onChange).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', onChange);
  onChange();
})();